import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  align-items: center;
  border-radius: 4px;
  box-sizing: border-box;
  width: 100%;
`;


export const TextContainer = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const ErrorText = styled.p`
  margin: 0;
  color: #FFFFFF;
`;


export const IconContainer = styled.div`
  position: relative;
  width: 125px;
  padding: 5px;
  height: 62px;
  margin-right: 12px;
  flex-shrink: 0;
  border-radius: 5px;
  background-color: ${props => props.backgroundColor || '#E6F4FF'};
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
`;

export const IconText = styled.div`
  position: relative;
  color: ${props => props.textColor || '#333333'};
  font-weight: bold;
  font-size: ${props => props.fontSize || '14px'};
  z-index: 2;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;


